import React, { Component } from "react";
import {
    Route,
    NavLink,
    HashRouter
  } from "react-router-dom";
import Order from "./Order";
import Customer from "./Customer";
import Vendor from "./Vendor";
import Item from "./Item";
import Calc from './Calc';
import { ToastContainer } from 'react-toastify';
 
class Main extends Component {

    render() {
        return (
            <HashRouter>
                <div>
                    <ToastContainer />
                    <h1>GSA App</h1>
                    <ul className="header">
                        <li><NavLink exact to="/">Order</NavLink></li>
                        <li><NavLink to="/customer">Customer</NavLink></li>
                        <li><NavLink to="/vendor">Vendor</NavLink></li>
                        <li><NavLink to="/item">Item</NavLink></li>
                        <li><NavLink to="/calculator">MS Item Price Calc</NavLink></li>
                    </ul>
                    <div className="content">
                        <Route exact path="/" component={Order}/>
                        <Route path="/customer" component={Customer}/>
                        <Route path="/vendor" component={Vendor}/>
                        <Route path="/item" component={Item}/>
                        <Route path="/calculator" component={Calc}/>
                    </div>
                </div>
            </HashRouter>
        );
  }
}
 
export default Main;


// WEBPACK FOOTER //
// ./src/js/Main.js